import Carousel from 'react-bootstrap/Carousel';

function BuildingsCarousel() {
  return (
    <Carousel  indicators={false} className="services-slides projects-slides" >
      <Carousel.Item>
        <img
          className="d-block w-100"
          src="./images/82.jpg"
          alt="First slide"
        />
      </Carousel.Item>
      <Carousel.Item>
        <img
          className="d-block w-100"
          src="./images/83.jpg"
          alt="First slide"
        />
      </Carousel.Item>
      <Carousel.Item>
        <img
          className="d-block w-100"
          src="./images/84.jpg"
          alt="First slide"
        />
      </Carousel.Item>
    
    </Carousel>
  );
}

export default BuildingsCarousel;